import { View, TouchableOpacity } from "react-native"
import { walkthroughable } from "react-native-copilot"

export const WalkthroughableView = walkthroughable(View)
export const WalkthroughableTouchableOpacity = walkthroughable(TouchableOpacity)
